import { DocumentDuplicateIcon, XMarkIcon } from '@heroicons/react/16/solid';
import React, { useState } from 'react';

export default function SharePodcast({ activeEpisode, isDark, showShare, onClose }) {

    const bgColor = () => isDark ? " bg-[#535860] " : " bg-white "
    const textColor = () => isDark ? " text-gray-200 " : " text-black "
    const textColorLight = () => isDark ? " text-gray-300 " : " text-gray-500 "
    const buttons = () => isDark ? "#B2B9C4" : "black"

    const shareUrl = activeEpisode?.link ?? "";
    const [clicked, setClicked] = useState(false)
    return (
        <div className={bgColor() + ` shadow-lg w-90 sm:w-2/5 z-10 absolute my-1 mx-1 bottom-16 right-0 overflow-y-scroll overflow-x-hidden transition-opacity duration-500 p-4 rounded-md ` + (showShare ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none')} >
            <div className={'relative flex-col justify-center' + textColor()}>
                <div className='cursor-pointer text-base absolute right-2' onClick={onClose}>
                    <XMarkIcon color={buttons()} className='w-6 h-6' />
                </div>
                <div className='text-lg font-bold'>Share</div>
                <div className='text-sm font-normal'>{activeEpisode.title}</div>
                <div className={"text-center  text-sm font-normal" + textColorLight()}>
                    <div className="grid grid-cols-2 sm:grid-cols-4 my-4 items-center">
                        <div className='flex w-full justify-center'>
                            <a
                                href={
                                    "https://www.facebook.com/sharer/sharer.php?u=" +
                                    `${shareUrl}`
                                }
                                target="_blank"
                                className="p-2 rounded-full bg-[#ffffffe6] h-8 sm:h-12 w-fit items-center flex justify-center m-[0.1rem]"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1.5rem"
                                    width="1.5rem"
                                    viewBox="0 0 24 24"
                                    fill="#4267B2"
                                >
                                    <path d="M24 1.327c0-.733-.595-1.327-1.327-1.327h-21.346c-.732 0-1.327.594-1.327 1.327v21.346c0 .732.595 1.327 1.327 1.327h11.505v-9.309h-3.126v-3.63h3.126v-2.667c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.794.143v3.243l-1.918.001c-1.504 0-1.795.715-1.795 1.764v2.305h3.589l-.467 3.63h-3.122v9.309h6.115c.732 0 1.327-.595 1.327-1.327v-21.346z" />
                                </svg>
                            </a>
                        </div>
                        <div className='flex w-full justify-center'>

                            <a
                                href={
                                    "https://x.com/share?url=" +
                                    `${shareUrl}`
                                }
                                target="_blank"
                                className="p-2 rounded-full bg-[#ffffffe6] h-8 sm:h-12 w-fit items-center flex justify-center  m-[0.1rem]"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    shape-rendering="geometricPrecision"
                                    text-rendering="geometricPrecision"
                                    image-rendering="optimizeQuality"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    height="1.5rem"
                                    width="1.5rem"
                                    viewBox="0 0 512 509.64">
                                    <rect width="512" height="509.64" rx="115.61" ry="115.61" />
                                    <path fill="#fff" fill-rule="nonzero" d="M323.74 148.35h36.12l-78.91 90.2 92.83 122.73h-72.69l-56.93-74.43-65.15 74.43h-36.14l84.4-96.47-89.05-116.46h74.53l51.46 68.04 59.53-68.04zm-12.68 191.31h20.02l-129.2-170.82H180.4l130.66 170.82z" />
                                </svg>
                            </a>
                        </div>
                        <div className='flex w-full justify-center'>

                            <a
                                href={
                                    "https://api.whatsapp.com/send?text=" +
                                    `${shareUrl}`
                                }
                                target="_blank"
                                className="p-2 rounded-full bg-[#ffffffe6] h-8 sm:h-12 w-fit items-center flex justify-center "
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1.5rem"
                                    width="1.5rem"
                                    fill="#25D366"
                                    viewBox="0 0 448 512"
                                >
                                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                                </svg>
                            </a>
                        </div>
                        <div className='flex w-full justify-center'>
                            <a
                                href={
                                    "https://www.linkedin.com/shareArticle/?url=" +
                                    `${shareUrl}`
                                }
                                target="_blank"
                                className="p-2 rounded-full bg-[#ffffffe6] h-8 sm:h-12 w-fit items-center flex justify-center  m-[0.1rem]"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1.5rem"
                                    width="1.5rem"
                                    viewBox="0 0 448 512"
                                    fill="#0077B5"
                                >
                                    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                                </svg>
                            </a>
                        </div>
                        {navigator.share && (
                            <div className='flex w-full justify-center'>

                                <a
                                    onClick={() => {
                                        navigator.share({
                                            url: shareUrl,
                                        });
                                    }}
                                    target="_blank"
                                    className="p-2 rounded-full bg-[#ffffffe6] h-8 sm:h-12 w-fit items-center flex justify-center  m-[0.1rem]"
                                >
                                    <svg
                                        fill="#000000"
                                        height="1.5rem"
                                        width="1.5rem"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 210 210"
                                    >
                                        <g id="XMLID_27_">
                                            <path
                                                id="XMLID_28_"
                                                d="M25,80C11.215,80,0,91.215,0,105s11.215,25,25,25c13.785,0,25-11.215,25-25S38.785,80,25,80z"
                                            />
                                            <path
                                                id="XMLID_30_"
                                                d="M105,80c-13.785,0-25,11.215-25,25s11.215,25,25,25c13.785,0,25-11.215,25-25S118.785,80,105,80z"
                                            />
                                            <path
                                                id="XMLID_71_"
                                                d="M185,80c-13.785,0-25,11.215-25,25s11.215,25,25,25c13.785,0,25-11.215,25-25S198.785,80,185,80z"
                                            />
                                        </g>
                                    </svg>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
                <div className={'flex flex-row text-md space-x-2  items-center cursor-pointer ' + textColorLight()} onClick={() => {
                    if (clicked) return;
                    navigator.clipboard.writeText(shareUrl);
                    setClicked(true)
                    setTimeout(() => {
                        setClicked(false)
                    }, 1000)
                }}>
                    <DocumentDuplicateIcon className='h-4 w-4' color={buttons()} />
                    <div className={'hover:underline' + textColorLight()}>{clicked ? "Link Copied" : "Copy Episode Link"}</div>
                </div>
            </div>
        </div>
    )
}


